import React, { useState, useContext, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import ModalWindow from '../../layout/modalwindow/ModalWindow'
import Expirations from './forms/expirations/Expirations'
import OtherPriceInputForm from './forms/OtherPriceInputForm'
import PullOutInventoryForm from './forms/PullOutInventoryForm'
import { ContentInner } from '../../layout/Content'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AutoCompleteList from '../../layout/AutoCompleteList'
import { formatNumber, filterItemsSearch } from '../../utilities/utilities'
import { CustomerDetailsFormStyle, InvoiceParticularsStyle, InvoiceSummaryStyle, InvoiceInnerStyle } from './css/InvoiceInnerStyle'
import { invoiceControllerContext } from './InvoiceController'
import { appContext } from '../../../App'

function CustomerDetails(props) {
  const { reset, showCustomerDetails, setShowCustomerDetails } = props
  const soldToRef = useRef(null)
  const invoiceController = useContext(invoiceControllerContext)
  const [invoice, setInvoice] = invoiceController.invoice
  const { customersDetails } = invoiceController
  const [currentCustomerDetailsList, setCurrentCustomerDetailsList] = useState(null)
  const [activeInput, setActiveInput] = useState('')
  const [keyPressed, setKeyPressed] = useState('')
  const [itemClicked, setItemClicked] = useState(false)
  const [showCustomerDetailsContainerBackground, setShowCustomerDetailsContainerBackground] = useState(false)

  const setCustomerDetails = (customer_name) => {
    if (customersDetails) {
      let customerDetail = customersDetails.find(item => item.sold_to === customer_name)
      if (!customerDetail) customerDetail = { address: '', contact_number: '', remarks: '', rewards_points: 0 }
      invoice.customer_details = { ...invoice.customer_details, ...customerDetail }
    }
  }

  const onChange = (e) => {
    if (!keyPressed) return

    if (e.target.name === 'sold_to') setCustomerDetails(e.target.value)

    setInvoice({ ...invoice, customer_details: { ...invoice.customer_details, [e.target.name]: e.target.value } })

    if (e.target.name !== 'contact_number') {
      setActiveInput(e.target.name)
      // Get Customers Details
      const filteredItemList = filterItemsSearch(customersDetails.map(item => item[e.target.name]), e.target.value)
      setCurrentCustomerDetailsList(filteredItemList)
    }
  }

  const onBlurSoldTo = (e) => {
    if (e.target.value.trim() === '') {
      setInvoice({ ...invoice, customer_details: { ...invoice.customer_details, [e.target.name]: 'Walked-in Customer' }})
    }
  }

  const onKeyDown = (e) => {
    switch(e.key) {
      case '\\':
      case '*':
      case '+':
      case '[':
      case '(':
      case '?':
      case '$':
        if (e.target.name !== 'contact_number') setKeyPressed(false)
        break
      case 'Enter':
      case 'Tab':
      case 'Escape':
        if (e.target.name !== 'contact_number') {
          setCurrentCustomerDetailsList([])
          ReactDOM.unmountComponentAtNode(document.getElementById(e.target.name+'-acl-container'))
        }
        break
      default:
        setKeyPressed(e.key)
    }
  }

  useEffect(() => soldToRef.current.focus(), [])

  useEffect(() => {
    if (showCustomerDetails) soldToRef.current.focus()
    else {
      document.getElementById('item_name').focus()
      document.getElementById('invoice-particulars-container').scrollIntoView()
    }
  }, [showCustomerDetails])

  useEffect(() => { if (reset) soldToRef.current.focus() }, [reset])

  useEffect(() => {
    if (activeInput)
      if (currentCustomerDetailsList.length > 0)
        ReactDOM.render(
          <AutoCompleteList
            valueSetter={(value) => {
              if (activeInput === 'sold_to') setCustomerDetails(value)
              setInvoice({ ...invoice, customer_details: { ...invoice.customer_details, [activeInput]: value } })
            } }
            keyPressed={keyPressed}
            setItemClicked={setItemClicked}
            items={currentCustomerDetailsList}
          />, document.getElementById(activeInput+'-acl-container')
        )
      else
        ReactDOM.unmountComponentAtNode(document.getElementById(activeInput+'-acl-container'))

    if (keyPressed === 'ArrowUp' || keyPressed === 'ArrowDown') setKeyPressed('')

    if (itemClicked) {
      setItemClicked(false)
      setCurrentCustomerDetailsList([])
    }
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoice.customer_details.sold_to, invoice.customer_details.address, invoice.customer_details.remarks, keyPressed, itemClicked])

  // const onChangeInvoiceDate = (e) => {
  //   setInvoice({...invoice, invoice_date: e.target.value})
  // }

  return (
    <React.Fragment>
      <div id='customer-details-container'
        className={(showCustomerDetailsContainerBackground) ? 'customer-details-container-background' : '' }
        style={ { display: (showCustomerDetails) ? 'flex' : 'none', } }>
        <div className='form-container'>
          <div className='form-input-container'>
            <label>Invoice Date</label>
            <div className='input-container'>
              <input
                ref={soldToRef}
                id='invoice_date'
                name='invoice_date'
                type='date'
                value={invoice.invoice_date}
                onChange={(e) => setInvoice({...invoice, invoice_date: e.target.value})} />
            </div>
          </div>
          <div className='form-input-container'>
            <label>Sold To</label>
            <div className='input-container'>
              <input
                ref={soldToRef}
                id='sold_to'
                name='sold_to'
                type='text'
                autoComplete='off'
                value={invoice.customer_details.sold_to}
                onKeyDown={onKeyDown}
                onBlur={onBlurSoldTo}
                onChange={onChange} />
              <div id='sold_to-acl-container' className='acl-container'></div>
            </div>
          </div>
          <div className='form-input-container'>
            <label>Address</label>
            <div className='input-container'>
              <input
                id='address'
                name='address'
                type='text'
                autoComplete='off'
                value={invoice.customer_details.address}
                onKeyDown={onKeyDown}
                onChange={onChange} />
              <div id='address-acl-container' className='acl-container'></div>
            </div>
          </div>
          <div className='form-input-container'>
            <label>Contact Number</label>
            <div className='input-container'>
              <input
                id='contact_number'
                name='contact_number'
                type='text'
                autoComplete='off'
                value={invoice.customer_details.contact_number}
                onKeyDown={onKeyDown}
                onChange={onChange} />
            </div>
          </div>
          <div className='form-input-container'>
            <label>Remarks</label>
            <div className='input-container'>
              <input
                id='remarks'
                name='remarks'
                type='text'
                autoComplete='off'
                onKeyDown={onKeyDown}
                value={invoice.customer_details.remarks}
                onChange={onChange} />
              <div id='remarks-acl-container' className='acl-container'></div>
            </div>
          </div>
          <div className='form-input-container'>
            <label>Reward's Points</label>
            <div className='input-container'>
              <input
                id='rewards_points'
                name='rewards_points'
                type='text'
                autoComplete='off'
                value={invoice.customer_details.rewards_points}
                readOnly='readOnly' />
            </div>
          </div>
        </div>
        <div id='button-hide-customer-details-container'>
          <button
            onMouseLeave={() => setShowCustomerDetailsContainerBackground(false)}
            onMouseOver={() => setShowCustomerDetailsContainerBackground(true)}
            onClick={() => setShowCustomerDetails(false)}
            className='pospro-action-btn hide-btn'>
            [ - ]
          </button>
        </div>
      </div>
      <CustomerDetailsFormStyle />
    </React.Fragment>
  )
}

function InvoiceParticulars({ reset }) {
  const app = useContext(appContext)
  const itemNameRef = useRef(null)
  const itemUnitQuantityRef = useRef(null)
  const invoiceController = useContext(invoiceControllerContext)
  const { reCalcInvoiceSummary, addPulledOutItemHistory, updateItemQuantity,
    restorePulledOutItems, getItemInventory, productsList } = invoiceController
  const [invoice, setInvoice] = invoiceController.invoice
  const [currentItemNamesList, setCurrentItemNamesList] = useState([])
  const [keyPressed, setKeyPressed] = useState(false)
  const [activeInput, setActiveInput] = useState(null)
  const [itemClicked, setItemClicked] = useState(false)

  /** Helper functions */
  async function updateItemInventory(mode, ip) {
    await updateItemQuantity(app, invoice.warehouse.id, {mode, ip})
  }

  /* actually unit_id is enough and item_id is overkill but adds convinients as needed */
  const initInvoiceParticular = {
    item_id: '',
    item_name: '',
    unit_id: '',
    unit: '',
    net_profit: 0.00, // is (unit_price - capital_amount)
    unit_price: 0.00,
    quantity: 1,
    amount: 0.00,
    item_remarks: '',
    expiration_date: '',
  }
  const [invoiceParticular, setInvoiceParticular] = useState(initInvoiceParticular)
  const [currentItem, setCurrentItem] = useState(null)
  const [currentItemUnitPrices, setCurrentItemUnitPrices] = useState(null)
  const [enableAddItemButton, setEnableAddItemButton] = useState(false)
  const [editMode, setEditMode] = useState(false)
  const [itemIndex, setItemIndex] = useState(null)
  const [currentUnitIsFractional, setCurrentUnitIsFractional] = useState(null)
  const [isBarcode, setIsBarcode] = useState(false)

  const onChange = (e) => {
    const setOtherPriceForm = () => {
      ReactDOM.render(
        <ModalWindow
          id='mw-parent'
          header='Other Price'
          footer={null}>
          <OtherPriceInputForm
            invoiceParticular={[invoiceParticular, setInvoiceParticular]}
            currentItemUnitPrices={[currentItemUnitPrices, setCurrentItemUnitPrices]}
          />
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }

    if (!keyPressed) { return }

    setActiveInput(e.target.name)

    if ((e.target.name === 'unit_price') && (e.target.value === 'Other price...')) {
      setOtherPriceForm()
    } else {
      setInvoiceParticular({ ...invoiceParticular, [e.target.name]: e.target.value })
      if (e.target.name === 'item_name') {

        const item_name = e.target.value

        // If it's a barcode
        if ((item_name.length === 13) && (!isNaN(item_name))) {
          let item
          productsList.forEach(product => {
            //item = product.units.find(unit => (unit.id === parseInt(item_name)))
            item = product.units.find(unit => (unit.id === item_name))
            if (item) {
              setIsBarcode(true)
              setInvoiceParticular({ ...invoiceParticular, [e.target.name]: product.item_full_description, unit: item.description })
              return
            }
          })
        }

        // Otherwise do the item search if the item_name is an item name literally
        const filteredItemList = filterItemsSearch(productsList.map(item => item.item_full_description), e.target.value)
        setCurrentItemNamesList(filteredItemList)
        document.getElementById('invoice-particulars-container').scrollIntoView()
      }
    }
  }

  const onKeyDown = (e) => {
    switch(e.key) {
      case '\\':
      case '*':
      case '+':
      case '[':
      case '(':
      case '?':
      case '$':
        setKeyPressed(false)
        break
      case 'Enter':
      case 'Tab':
      case 'Escape':
        setCurrentItemNamesList([])
        ReactDOM.unmountComponentAtNode(document.getElementById(e.target.name+'-acl-container'))
        setKeyPressed(e.key)
        break
      default:
        setKeyPressed(e.key)
    }
  }

  const onInvoiceParticularAddItem = async (e) => {
    const showOutOfStockMessageBox = () => {
      ReactDOM.render (
        <ModalWindow
          id='mw-parent'
          width='30'
          height='25'
          header="Item Unit Out-of-Stock"
          footer={null}>
            <div className='messagebox'>
              <div className='messagebox-content' style={{fontSize: '1rem'}}>
                <p><b>{invoiceParticular.item_name+"'s"}</b> <i>{invoiceParticular.unit}</i> is out-of-stock!</p>
              </div>
              <div className='button-container'>
                <button
                  onClick={() => { ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container')) }}
                  className='pospro-action-btn top-anchor'>
                  Ok
                 </button>
              </div>
            </div>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }

    const showPullOutInventoryForm = async (ci) => {
      const buttonClicked = (button) => {
        if (button === 'Apply') addInvoiceParticular()
      }

      const pullOutFormProps = {
        ci,
        invoiceParticular,
        addPulledOutItemHistory,
        updateItemInventory,
        buttonClicked
      }
      
      ReactDOM.render(
        <ModalWindow
          id='mw-parent'
          header='Item Unit Out-of-Stock'
          footer={`${invoiceParticular.item_name}`}>
          <PullOutInventoryForm { ...pullOutFormProps } />
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }

    const updateItemsQuantityAndAmount = () => {
      // ... upate item's quantity and amount
      let item_to_update = invoice.invoice_particulars.find((item) => (
        (item.item_name === invoiceParticular.item_name) &&
        (item.unit === invoiceParticular.unit)) &&
        (item.unit_price === invoiceParticular.unit_price) &&
        (item.expiration_date === invoiceParticular.expiration_date)
      )
      if (item_to_update) {
        item_to_update.quantity = parseFloat(item_to_update.quantity) + parseFloat(invoiceParticular.quantity)
        item_to_update.net_profit = parseFloat(item_to_update.net_profit) + parseFloat(invoiceParticular.net_profit)
        item_to_update.amount = parseFloat(item_to_update.quantity * item_to_update.unit_price)
      }

      reCalcInvoiceSummary()
    }

    const addInvoiceParticular = async () => {
      // Will find the item
      const foundCurrentInvoiceParticularOnInvoice = () => {
        const item_found =
          invoice.invoice_particulars.find((item, index) => (
              (item.item_name === invoiceParticular.item_name) &&
              (item.unit === invoiceParticular.unit) &&
              (item.unit_price === invoiceParticular.unit_price) &&
              (item.expiration_date === invoiceParticular.expiration_date) &&
              ((editMode) ? (index !== itemIndex) : true)
            )
          )

        // return the index that will be use for animateInput()
        if (item_found) {
          const index = invoice.invoice_particulars.findIndex(item => (item.item_id === item_found.item_id))
          return index
        } else return (-1)
      }

      // Will add animation on item inputted
      const animateInput = (index=0) => {
        const tb = document.getElementById(index+'tbody-items-group')
        tb.classList.add('decolorize')
        setTimeout(() => {
          tb.classList.remove('decolorize')
        }, 3000)
      }

      const foundInvoiceParticular = foundCurrentInvoiceParticularOnInvoice()

      if (editMode) {
        // If item with particular item unit
        // (which is not equal to the current item index being edited) is already on the list then
        if (foundInvoiceParticular !== -1) {
          // Update item and quantity on view
          updateItemsQuantityAndAmount()

          // Remove the item being edited from the list after update
          setInvoice({
            ...invoice,
            invoice_particulars: [ ...invoice.invoice_particulars.filter((item, index) => index !== itemIndex) ]
          })
        } else {

          // Add percent_off_remarks to the item_remarks
          if (invoiceParticular.percent_off) {
            const percent_off_remarks = `- ${invoiceParticular.percent_off}% off ${invoiceParticular.percent_off_remarks}`
            if (invoiceParticular.item_remarks) invoiceParticular.item_remarks += (' ' + percent_off_remarks)
            else invoiceParticular.item_remarks = percent_off_remarks
          }

          invoice.invoice_particulars[itemIndex] = invoiceParticular
          reCalcInvoiceSummary()
        }

        // Delete editMode field in invoice particular, it's no longer needed
        delete invoice.invoice_particulars[itemIndex].editMode

        setEditMode(false)

      } else {
        // If item with particular item unit is already in the list then
        if (foundInvoiceParticular !== -1) updateItemsQuantityAndAmount()
        // else add the new item
        else {

          // Add percent_off_remarks to the item_remarks
          if (invoiceParticular.percent_off) {
            const percent_off_remarks = `- ${invoiceParticular.percent_off}% off ${invoiceParticular.percent_off_remarks}`
            if (invoiceParticular.item_remarks) invoiceParticular.item_remarks += (' ' + percent_off_remarks)
            else invoiceParticular.item_remarks = percent_off_remarks
          }

          setInvoice({
            ...invoice,
            invoice_particulars: [ invoiceParticular, ...invoice.invoice_particulars ]
          })

        }
      }

      // Update items quantity on the database
      await updateItemQuantity(app, invoice.warehouse.id, { mode: -1, ip: invoiceParticular })

      // Resets
      setCurrentItem(null)
      setInvoiceParticular(initInvoiceParticular)
      setEnableAddItemButton(false)

      itemNameRef.current.focus()
      document.getElementById('invoice-particulars-container').scrollIntoView()

      if (editMode) animateInput(itemIndex)
      else animateInput((foundInvoiceParticular === -1) ? 0 : foundInvoiceParticular)
    }

    const showExpirationsList = (ci, pull_out = false) => {

      const getExpirationsByPullout = () => {
        // Exclude the unit requesting pull-out
        const currentItemAvailableUnits = ci.units
          .filter(item => ((item.description !== invoiceParticular.unit) && item.inventory > 0))

        let arr_expirations = [] // [] instead of null to accept .push array function
        
        currentItemAvailableUnits.forEach(ciu => {
          const ciu_warehouse = ciu.warehouses.find(wh => wh.warehouse_id === invoice.warehouse.id)
          let parsed_array = []
          if (ciu_warehouse.expirations) {
            parsed_array = JSON.parse(JSON.stringify(ciu_warehouse.expirations))
            parsed_array.forEach(pa => pa.unit = ciu.description)
          }
          arr_expirations.push(...parsed_array)
        })

        arr_expirations = (arr_expirations.length) ? arr_expirations : null
        return (arr_expirations)
      }

      const getExpirations = () => {
        // It's more accurate to query expirations here
        const currentItemUnit = ci.units.find(unit => unit.description === invoiceParticular.unit)
        // Get expirations array
        const item_unit_current_warehouse = currentItemUnit.warehouses
        .find(wh => wh.warehouse_id === invoice.warehouse.id)

        // Clone expirations from currentItem
        let arr_expirations = null
        if (item_unit_current_warehouse) {
          if (item_unit_current_warehouse.expirations) {
            arr_expirations = JSON.parse(JSON.stringify(item_unit_current_warehouse.expirations))
            arr_expirations = (arr_expirations.length) ? arr_expirations : null
          }
        }

        return (arr_expirations)
      }

      const show = () => {
        const cb = async (res) => {
          if (pull_out) {
            ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
            showPullOutInventoryForm(ci)
          } else {
            addInvoiceParticular()
            ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
          }
        }

        ReactDOM.render(
          <ModalWindow
            id='mw-parent'
            width='30'
            height='50'
            header='Select Expiration Date'
            footer={(invoiceParticular.expiration_date)
              ? `Edit Expiration Date: ${invoiceParticular.expiration_date}`
              : null
            }>
            <Expirations invoiceParticular={invoiceParticular} app={app} cb={cb} pullOut={pull_out} />
          </ModalWindow>,
          document.getElementById('modal-form-container')
        )
      }

      if (pull_out) { invoiceParticular.expirations = getExpirationsByPullout(item.current) }
      else invoiceParticular.expirations = getExpirations(item.currentItem)

      if (invoiceParticular.expirations) show()
      else {
        if (pull_out) {
          showPullOutInventoryForm(ci)
        } else addInvoiceParticular()
      }
    }

    // New solution
    // This is more accurate than using currentItem
    const item = await getItemInventory(app, invoice.warehouse.id, invoiceParticular)

    if (item) {
      // Check if current's item's is out of stock
      if ((item.inventory - invoiceParticular.quantity) < 0) {
        (item.out_of_stock) ? showOutOfStockMessageBox() : showExpirationsList(item.currentItem, true)
      } else {
        // Get item expirations
        // Not pulling out by default (false)
        showExpirationsList(item.currentItem)
      }
    }
  }

  const onClickDDButton = (e) => {
    const dd_menu = e.target.closest('.dd-menu')
    const index = parseInt(e.target.id)

    // Hide all previously oppened action buttons except the current active
    const action_btn_menu_all = document.querySelectorAll('.action-btn-menu')
    action_btn_menu_all.forEach((act_btn, i) => {
      if (i !== index) act_btn.classList.remove('show-dd-menu')
    })

    const action_btn_menu = dd_menu.querySelector('.action-btn-menu')
    action_btn_menu.classList.toggle('show-dd-menu')
  }

  const onDDFocus = (e) => {
    const index = parseInt(e.target.id)

    // Hide all previously oppened action buttons except the current active
    const action_btn_menu_all = document.querySelectorAll('.action-btn-menu')
    action_btn_menu_all.forEach((act_btn, i) => {
      if (i !== index) act_btn.classList.remove('show-dd-menu')
    })
  }

  const onClickEditRow = async (e) => {
    // Hide pop-up action button
    const dd_menu = e.target.closest('.dd-menu')
    const action_btn_menu = dd_menu.querySelector('.action-btn-menu')
    if (action_btn_menu.classList.contains('show-dd-menu'))
      action_btn_menu.classList.remove('show-dd-menu')

    const item_index = parseInt(e.target.id)

    const invoice_particular = invoice.invoice_particulars[item_index]

    // Restore the item's quantity being edited first
    await updateItemQuantity(app, invoice.warehouse.id, { mode: 1, ip: invoice_particular })

    // Restore pulled-out history here as well
    await restorePulledOutItems(invoice_particular)

    setItemIndex(item_index)

    const percent_off_remarks = `- ${invoice_particular.percent_off}% off ${invoice_particular.percent_off_remarks}`
    invoice_particular.editMode = true

    const percent_off_remarks_found = invoice_particular.item_remarks.search(percent_off_remarks)
    if (invoice_particular.percent_off) {
      if (percent_off_remarks_found >= 0) {
        const item_remarks = invoice_particular.item_remarks.substr(0, (percent_off_remarks_found - 1))
        invoice_particular.item_remarks = item_remarks
      }
    }

    setInvoiceParticular(invoice_particular)

    setEditMode(true)
    itemUnitQuantityRef.current.focus()
    document.getElementById('invoice-particulars-container').scrollIntoView()

    setKeyPressed(true)
  }

  const onClickDelRow = async (e) => {
    const item_index = parseInt(e.target.id)

    // Restore this deleted Item quantity to the database
    await updateItemQuantity(app, invoice.warehouse.id, {mode: 1, ip: invoice.invoice_particulars[item_index]})

    // Restore pulled-out history here as well specifying that it is invoice delete mode
    await restorePulledOutItems(invoice.invoice_particulars[item_index])

    // Remove the item selected for deletion using it's index on the View
    setInvoice({
      ...invoice,
      invoice_particulars: [ ...invoice.invoice_particulars.filter((item, index) => index !== item_index) ]
    })

    itemNameRef.current.focus()
    document.getElementById('invoice-particulars-container').scrollIntoView()
  }

  const onItemRemarksFocus = (e) => {
    const action_btn_menu_all = document.querySelectorAll('.action-btn-menu')
    action_btn_menu_all.forEach((act_btn, i) => {
      if (act_btn.classList.contains('show-dd-menu')) act_btn.classList.remove('show-dd-menu')
    })
  }

  /**************************************************
   * Effects
   **************************************************/
  useEffect(() => {
    if (reset) {
      setInvoiceParticular(initInvoiceParticular)
    }
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reset])

  useEffect(() => {
    if (activeInput !== 'item_name') return

    if (currentItemNamesList.length > 0) {
      ReactDOM.render(
        <AutoCompleteList
          valueSetter={(value) => setInvoiceParticular({ ...invoiceParticular, [activeInput]: value })}
          keyPressed={keyPressed}
          setItemClicked={setItemClicked}
          items={currentItemNamesList}
        />, document.getElementById(activeInput+'-acl-container')
      )
    } else
      ReactDOM.unmountComponentAtNode(document.getElementById(activeInput+'-acl-container'))

    if (keyPressed === 'ArrowUp' || keyPressed === 'ArrowDown') setKeyPressed(false)

    if (itemClicked) {
      setItemClicked(false)
      setCurrentItemNamesList([])
    }
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceParticular.item_name, keyPressed, itemClicked])

  useEffect(() => {
    // Get Current Item Details
    if (productsList) {
      const current_item = productsList.find(item => item.item_full_description === invoiceParticular.item_name)

      if (current_item) {
        setCurrentItem(current_item)

        let ci = null
        if (isBarcode) {
          ci = {
            item_id: current_item._id,
            quantity: 1
          }
          //setIsBarcode(false)
        } else {
          ci = {
            item_id: current_item._id,
            unit: current_item.units[0].description,
            quantity: 1
          }
        }

        setInvoiceParticular({
          ...invoiceParticular, ...ci
        })

      } else {
        setCurrentItem(null)
        setCurrentItemUnitPrices(null)
      }
    }
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceParticular.item_name])

  useEffect(() => {
    if (currentItem) {
      const currentItemUnit = currentItem.units.find(item => item.description === invoiceParticular.unit)

      if (currentItemUnit)  {
        const tempPrices = [
          (parseFloat((100 - currentItemUnit.percent_off) / 100) * parseFloat(currentItemUnit.retail_price.toFixed(2))),
          parseFloat(currentItemUnit.wholesale_price.toFixed(2))
        ]
        setCurrentItemUnitPrices([ ...tempPrices, 'Other price...' ])

        // Know if it accepts fraction number
        setCurrentUnitIsFractional(currentItemUnit.fractional)

        setInvoiceParticular({
          ...invoiceParticular,
          unit_id: currentItemUnit.id,
          capital_amount: parseFloat(currentItemUnit.capital_amount),
          unit_price: (parseFloat((100 - currentItemUnit.percent_off) / 100) * parseFloat(currentItemUnit.retail_price.toFixed(2))),
          //parseFloat(currentItemUnit.retail_price.toFixed(2)),
          quantity: 1,
          vatable: currentItemUnit.vatable,
          percent_off: currentItemUnit.percent_off,
          percent_off_remarks: currentItemUnit.percent_off_remarks
        })
      }
    }
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceParticular.unit, currentItem])

  useEffect(() => {
    // Enable [+] button only if this condition is true
    setEnableAddItemButton(Boolean(currentItem) && (invoiceParticular.unit !== '') && (invoiceParticular.quantity > 0))
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceParticular])

  useEffect(() => {
    const capitalAmount = parseFloat(invoiceParticular.capital_amount)
    const unitPrice = parseFloat(invoiceParticular.unit_price)
    const quantity = parseFloat(invoiceParticular.quantity)
    const amount = (unitPrice * quantity) ? (unitPrice * quantity) : 0.00
    const net_profit = ((unitPrice - capitalAmount) * quantity)
    setInvoiceParticular({ ...invoiceParticular, amount: parseFloat(amount.toFixed(2)), net_profit: parseFloat(net_profit) })
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceParticular.unit_price, invoiceParticular.quantity])

  useEffect(() => {
    if (isBarcode) {
      onInvoiceParticularAddItem()
      setIsBarcode(false)
    }
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceParticular.amount])

  useEffect(() => {
    const item_details_row = document.getElementById(itemIndex+'item-details-row')
    const item_details_remarks = document.getElementById(itemIndex+'item-remarks')

    // Set/Remove highlight the item being edited
    if (editMode) {
      if (item_details_row) item_details_row.classList.add('highlight-item-details-row')
      if (item_details_remarks) item_details_remarks.classList.add('highlight-item-details-row')
    } else {
      if (item_details_row) item_details_row.classList.remove('highlight-item-details-row')
      if (item_details_remarks) item_details_remarks.classList.remove('highlight-item-details-row')
    }

    if (editMode) {
      if (currentItem) {
        const currentItemUnit = currentItem.units.find(item => item.description === invoiceParticular.unit)
        if (currentItemUnit) {
          const tempPrices = [
            //parseFloat(currentItemUnit.retail_price.toFixed(2)),
            (parseFloat((100 - currentItemUnit.percent_off) / 100) * parseFloat(currentItemUnit.retail_price.toFixed(2))),
            parseFloat(currentItemUnit.wholesale_price.toFixed(2))
          ]
          // Set the price either the price is other price or standard/default prices
          if (!tempPrices.find((price) => (price === invoiceParticular.unit_price)))
            setCurrentItemUnitPrices([ ...tempPrices, invoiceParticular.unit_price, 'Other price...' ])
          setInvoiceParticular({ ...invoiceParticular, unit_price: parseFloat(invoiceParticular.unit_price) })
        }
      }
    }
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editMode])

  return (
    <React.Fragment>
      <div id='invoice-particulars-container'>
        <div className='table-container'>
          <table
            id='invoice-particulars-form-table'
            className='invoice-particulars-table'>
            <thead className='thead-header-group'>
              <tr>
                <th>#</th>
                <th>Item Name</th>
                <th>Unit</th>
                <th style={{textAlign: 'right'}}>Unit Price</th>
                <th style={{textAlign: 'center'}}>Quantity</th>
                <th style={{textAlign: 'right'}}>Amount</th>
                <th style={{textAlign: 'center'}}>Action</th>
              </tr>
            </thead>
            <thead className='thead-input-group'>
              <tr>
                <th></th>
                <th>
                  <div className='input-container'>
                    <input
                      ref={itemNameRef}
                      id='item_name'
                      name='item_name'
                      className='invoice-particular-input'
                      autoComplete='off'
                      placeholder='search in brand, name, description'
                      onKeyDown={onKeyDown}
                      onChange={onChange}
                      value={invoiceParticular.item_name}
                      type='text'
                    />
                    <div id='item_name-acl-container' className='acl-container'></div>
                  </div>
                </th>
                <th>
                  <select
                    id='unit'
                    name='unit'
                    className='invoice-particular-input'
                    onChange={onChange}
                    value={invoiceParticular.unit}>
                    {
                      currentItem ?
                        currentItem.units.map((item, index) => (
                            <option key={index}>{item.description}</option>
                          )
                        )
                        : null
                    }
                  </select>
                </th>
                <th>
                  <select
                    style={{textAlign: 'right'}}
                    id='unit_price'
                    name='unit_price'
                    className='invoice-particular-input'
                    onChange={onChange}
                    value={invoiceParticular.unit_price}>
                    {
                      currentItemUnitPrices ?
                        currentItemUnitPrices.map((price, index) => (
                          <option key={index}>{price}</option>
                        ))
                      : null
                    }
                  </select>
                </th>
                <th>
                  <input
                    ref={itemUnitQuantityRef}
                    style={{textAlign: 'center'}}
                    id='quantity'
                    name='quantity'
                    className='invoice-particular-input'
                    onChange={(e) =>
                      setInvoiceParticular({
                        ...invoiceParticular,
                        quantity: currentUnitIsFractional ? parseFloat(e.target.value) : parseInt(e.target.value)
                      })
                    }
                    value={invoiceParticular.quantity}
                    type='number'/>
                </th>
                <th>
                  <input
                    style={{textAlign: 'right', backgroundColor: 'lightgrey'}}
                    id='amount'
                    name='amount'
                    autoComplete='off'
                    className='invoice-particular-input'
                    readOnly='readOnly'
                    value={invoiceParticular.amount.toFixed(2)}
                    type='number'/>
                </th>
                <th rowSpan='2'>
                  <div id='ip-action-buttons-container'>
                    <button
                      id='invoice-particular-add-item'
                      onClick={onInvoiceParticularAddItem}
                      className={ enableAddItemButton ? 'pospro-action-btn' : 'pospro-action-btn disabled-button' }
                      disabled={!enableAddItemButton}>
                      <FontAwesomeIcon icon='plus'/>
                    </button>
                  </div>
                </th>
              </tr>
              <tr>
                <th></th>
                <th style={{textAlign: 'left'}} colSpan='5'>
                  <input
                    id='item_remarks'
                    name='item_remarks'
                    type='text'
                    className='invoice-particular-input'
                    value={invoiceParticular.item_remarks}
                    onChange={onChange}
                    onFocus={onItemRemarksFocus}
                    placeholder='Item Remarks'
                  />
                </th>
              </tr>
            </thead>
          </table>
          <div id='invoice-particulars-items-table-container'>
            <table
              id='invoice-particulars-items-table'
              className='invoice-particulars-table striped-table'>
              {
                invoice.invoice_particulars ?
                  invoice.invoice_particulars.map((item, index) => (
                    <tbody key={item.unit_id + index} id={index+'tbody-items-group'} className='tbody-items-group'>
                      <tr id={index+'item-details-row'}>
                        <td rowSpan='2'>{index+1}</td>
                        <td>
                          <div>{item.item_name}</div>
                          <div
                            style={{display: (item.expiration_date) ? 'block' : 'none'}}
                            className='expiration-date-container'>
                            Expiration Date:&nbsp; <span className='item-expiration-date'>{item.expiration_date}</span>
                            {/*&nbsp;<CloseButton id={index+'cb'} cb={onClickRemoveExpirationDate} scale={0.8}/>*/}
                          </div>
                        </td>
                        <td>{item.unit}</td>
                        <td style={{textAlign: 'right'}}>P{formatNumber(item.unit_price)}</td>
                        <td style={{textAlign: 'center'}}>{formatNumber(item.quantity)}</td>
                        <td style={{textAlign: 'right'}}>P{formatNumber(item.amount) + ((item.vatable) ? '(V)' : '')}</td>
                        <td style={{textAlign: 'center'}} rowSpan='2'>
                          <div key={index} className='dd-menu'>
                            <button
                              id={index+'action-row-btn'}
                              onClick={onClickDDButton}
                              onFocus={onDDFocus}
                              className={editMode ? 'pospro-action-btn ellips-btn disabled-button' : 'pospro-action-btn ellips-btn'}
                              disabled={editMode}>
                              <FontAwesomeIcon icon='ellipsis-v'/>
                            </button>
                            <div className='action-btn-menu'>
                              <button
                                id={index+'edit-row-btn'}
                                onClick={onClickEditRow}
                                className="pospro-action-btn edit-row-btn">
                                e
                              </button>
                              <button
                                id={index+'del-row-btn'}
                                onClick={onClickDelRow}
                                className="pospro-action-btn del-row-btn">
                                &times;
                              </button>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr id={index+'item-remarks'} style={{display: item.item_remarks ? 'table-row' : 'none'}}>
                        <td id='ip-item-remarks' colSpan='5'>{item.item_remarks}</td>
                      </tr>
                    </tbody>
                  ))
                  : ''
              }
            </table>
          </div>
        </div>
      </div>
      <InvoiceParticularsStyle />
    </React.Fragment>
  )
}

function InvoiceSummary({ reset }) { // reset is use to trigger rerender
  const invoiceController = useContext(invoiceControllerContext)
  const invoice = invoiceController.invoice[0]
  const invoiceSummary = invoice.invoice_summary

  return (
    <React.Fragment>
      <div id='invoice-summary-container'>
        <div className='form-container'>
          <div className='form-input-container'>
            <label>VATable Sales</label>
            <div className='input'>
              <div className='input-container'>
                <div>Amount</div>
                <span>P{formatNumber(invoiceSummary.vat_total_sales.toFixed(2) - invoiceSummary.vat_amount.toFixed(2))}</span>
              </div>
              <div className='input-container'>
                <div>VAT ({invoice.vat}%)</div>
                <span>P{formatNumber(invoiceSummary.vat_amount.toFixed(2))}</span>
              </div>
              <div className='input-container'>
                <div>Numbers Of Item</div>
                <span>{formatNumber(invoiceSummary.vat_total_items.toFixed(2))}</span>
              </div>
              <div className='input-container'>
                <div>Total</div>
                <span>P{formatNumber(invoiceSummary.vat_total_sales.toFixed(2))}</span>
              </div>
            </div>
          </div>
          <div className='form-input-container'>
            <label>None-VAT Sales</label>
            <div className='input'>
              <div className='input-container'>
                <div>Numbers Of Item</div>
                <span>{formatNumber(invoiceSummary.none_vat_total_items.toFixed(2))}</span>
              </div>
              <div className='input-container'>
                <div>Amount</div>
                <span>P{formatNumber(invoiceSummary.none_vat_total_sales.toFixed(2))}</span>
              </div>
            </div>
          </div>
          <div className='form-input-container'>
            <label>Grand Total Sales</label>
            <div className='input'>
              <div className='input-container'>
                <div>Numbers Of Item</div>
                <span>{formatNumber(invoiceSummary.total_item)}</span>
              </div>
              <div className='input-container'>
                <div>Amount</div>
                <span><b>P{formatNumber(invoiceSummary.total_sales.toFixed(2))}</b></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <InvoiceSummaryStyle />
    </React.Fragment>
  )
}

function InvoiceInner() {
  const invoiceController = useContext(invoiceControllerContext)
  const invoice = invoiceController.invoice[0]
  const { resetInvoice, restorePulledOutItems, restorePerfect } = invoiceController
  const [reset, setReset] = useState(false)
  const [showCustomerDetails, setShowCustomerDetails] = useState(false)

  const showMessageBox = async () => {
    if (invoice.invoice_particulars.length > 0) {
      const onClick = async (button) => {
        if (button === 'Yes') {
          await resetInvoice()
          await restorePulledOutItems()
          setReset(true)
          document.getElementById('item_name').focus()
        }

        ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
      }

      ReactDOM.render (
        <ModalWindow
          id='mw-parent'
          width='40'
          height='35'
          header="Reset/Clear Sales Invoice"
          footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content'>
              <div>This will clear all the fields of the current invoice form,
              at the same time will restore all unit you pulled-out from this transaction if possible.</div>
              <br/>
              <div>Do you want to continue?</div>
            </div>
            <div className='button-container'>
              <button onClick={() => { onClick('No') }} className='pospro-action-btn top-anchor'>No</button>
              <button onClick={() => { onClick('Yes') }} className='pospro-action-btn top-anchor'>Yes</button>
            </div>
          </div>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    } else {
      await resetInvoice()
      setReset(true)
      document.getElementById('item_name').focus()
    }
  }

  useEffect(() => {
    if (reset) { }
    return() => setReset(false)
  }, [reset])

  useEffect(() => {
    // I don't think this routine still works nor still applicable
    // I need to analyze this later
    if (!restorePerfect)
      ReactDOM.render (
        <ModalWindow
          id='mw-parent'
          width='40'
          height='40'
          header="Reset/Clear Sales Invoice"
          footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content'>
              <div>
                Some pulled-out item's can no longer be restored.
                Other process/transactions have already consumed the item's this transaction have pulled-out.
              </div>
              <br/>
            </div>
            <div className='button-container'>
              <button
                onClick={() => { ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container')) }}
                className='pospro-action-btn top-anchor'>
                Ok
              </button>
            </div>
          </div>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
  }, [restorePerfect])

  return (
    <ContentInner>
      <div id='invoices-container'>
        <div>
          <div className='header-title-container'>
            <div className='header-caption'>
              Preparing Sales Invoice for&nbsp;
              <button
                title='Edit customer details'
                id='show-customer-link'
                onClick={(e) => setShowCustomerDetails(!showCustomerDetails)}
                style={{visibility: (!showCustomerDetails) ? 'visible' : 'hidden'}}>
                { invoice.customer_details.sold_to }
              </button>
            </div>
            <button
              id='reset-invoice-btn'
              onClick={showMessageBox}
              className='pospro-action-btn reset-invoice-btn'>
              <FontAwesomeIcon icon='exclamation-circle'/>&nbsp;
              New/Reset Invoice
            </button>
          </div>
          <hr />
        </div>
        <div id='invoice-body'>
          <div id='invoice-left'>
            <CustomerDetails reset={reset} showCustomerDetails={showCustomerDetails} setShowCustomerDetails={setShowCustomerDetails}/>
            <InvoiceParticulars reset={reset} />
          </div>
          <div id='invoice-right'>
            <InvoiceSummary reset={reset} />
          </div>
        </div>
      </div>
      <InvoiceInnerStyle />
    </ContentInner>
  )
}

export default React.memo(InvoiceInner)